import { lazyNamed } from 'src/utils/lazyNamed';

const Payouts = {
  Statistics: lazyNamed(() => import('./containers/Statistics'), 'Statistics'),
  Documents: lazyNamed(() => import('./containers/Documents'), 'Documents'),
  MultiPayouts: lazyNamed(() => import('./containers/MultiPayouts'), 'MultiPayouts'),
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
};

export default Payouts;
